import styles from "./SubscriptionsAndAddons.module.scss";
import Addons from "./Addons/Addons";
import Subscriptions from "./Subscriptions/Subscriptions";
import SearchInput from "../../components/SearchInput/SearchInput";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const SubscriptionsAndAddons = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState<string>("");

  const onClickSearch = () => {
    navigate(
      `/subscriptions/?searchValue=${inputValue}&shouldUpdateSubscriptions=${true}&shouldUpdateAddons=${true}`
    );
  };

  const onClickReset = () => {
    setInputValue("");
    navigate(
      `/subscriptions/?searchValue=&shouldUpdateSubscriptions=${true}&shouldUpdateAddons=${true}`
    );
  };

  return (
    <>
      <div style={{ padding: "20px", paddingBottom: "0", marginBottom: "-20px" }}>
        <SearchInput
          clickOnReset={onClickReset}
          addNewBtn={false}
          onClickSearch={onClickSearch}
          inputValue={inputValue}
          setInputValue={setInputValue}
          placeholder={t("SearchByCredits")}
        />
      </div>
      <Subscriptions />
      <div className={styles.border}></div>
      <Addons />
    </>
  );
};

export default SubscriptionsAndAddons;
